import { Injectable } from '@angular/core';
import { Client, ClientGroup } from './../interfaces/client.interface';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { QueryParams } from '../interfaces/request.interface';
import { catchError } from 'rxjs/operators';
import { ApiResponse } from '../interfaces/response.interface';
import { AbstractHttpController } from '../utils/class/AbstractHttpControllers';
import { PartialNestedObject } from '../interfaces/common.interface';
import { DATA_SOURCE } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends AbstractHttpController<Client> {
  protected _endpoint: string;
  protected _queryParams: QueryParams<Client>;
  public get queryParams(): QueryParams<Client> {
    return this._queryParams;
  }
  public set queryParams(queryParams: QueryParams<Client>) {
    this._queryParams = queryParams;
  }
  public find(args?: PartialNestedObject<Client>): Observable<ApiResponse<Client[]>> {
    throw new Error('Method not implemented.');
  }
  public findOne(args?: PartialNestedObject<Client>): Observable<ApiResponse<Client>> {
    throw new Error('Method not implemented.');
  }
  public findBy(args?: PartialNestedObject<Client>): Observable<ApiResponse<Client[]>> {
    return this.read<Client[]>({
      datasource:DATA_SOURCE.DMAESTROS,
      path: `${this._endpoint}/short`,
      queryParams: this._queryParams,
    })
  }
  public remove(args?: PartialNestedObject<Client>): Observable<ApiResponse<Client>> {
    throw new Error('Method not implemented.');
  }
  public make(args?: PartialNestedObject<Client>): Observable<ApiResponse<Client>> {
    throw new Error('Method not implemented.');
  }

  constructor(
    private readonly _httpClient: HttpClient,
  ) {
    super(_httpClient);
    this._endpoint = 'cliente';
  }
}
